import fetch from './fetch'
const client = fetch()

export const paths = {
  notifications: '/notifications'
}

export interface NotificationSource {
  event_id: number
  type: 'job_statuses' | 'recommendations' | 'datasources'
}

export interface Notification {
  id: string
  clientId: number
  message: string
  title: string
  severity: 'critical' | 'moderate' | 'low'
  source: NotificationSource
  metadata: object
  tags: string[]
  updatedAt: string
  updatedBy: string
  createdAt: string
  createdBy: string
}

export interface UserNotificationResp {
  clientId: number
  createdAt: string
  createdBy: number
  id: number
  isRead: boolean
  notification: Notification
  updatedAt: string
  updatedBy: string
  userId: number
}

export interface NotificationCountResp {
  count: number
}

export const getNotifications = async (clientId: number, unreadOnly = true): Promise<UserNotificationResp[]> => {
  return await client.get<UserNotificationResp[]>({
    path: `${paths.notifications}?client_id=${clientId}&unread_only=${unreadOnly}`
  })
}

export const getUnreadNotificationsCount = async (clientId: number): Promise<NotificationCountResp> => {
  return await client.get<NotificationCountResp>({
    path: `${paths.notifications}/count?client_id=${clientId}&unread_only=true`
  })
}

export const markNotificationAsRead = async (
  clientId: number,
  userNotificationIds: number[]
): Promise<UserNotificationResp[]> => {
  const BATCH_SIZE = 100
  const batches: number[][] = []

  for (let i = 0; i < userNotificationIds.length; i += BATCH_SIZE) {
    const slice = userNotificationIds.slice(i, i + BATCH_SIZE)
    batches.push(slice)
  }

  const results = await Promise.all(
    batches.map(
      async (batch) =>
        await client.post<UserNotificationResp>({
          path: `${paths.notifications}/batch-read`,
          data: {
            user_notification_ids: batch,
            client_id: clientId
          }
        })
    )
  )

  return results.flat()
}
